import { PrivilegesLists, privilegesListsIds } from "../constants/PrivilegesConstants.js";
var defaultPrivileges = [];
var ref;
var getPrivilegesList = function(state, id) {
    var ref1;
    return (ref = state === null || state === void 0 ? void 0 : (ref1 = state.privilegesLists) === null || ref1 === void 0 ? void 0 : ref1[id]) !== null && ref !== void 0 ? ref : defaultPrivileges;
};
var getUserPrivilegesList = function(state) {
    return getPrivilegesList(state, privilegesListsIds[PrivilegesLists.User]);
};
export var PrivilegesListSelector = {
    getPrivilegesList: getPrivilegesList,
    getUserPrivilegesList: getUserPrivilegesList
};

//# sourceMappingURL=PrivilegesListSelectors.js.map